<template>
	<v-navigation-drawer expand-on-hover rail>
		<v-list nav>
			<v-list-item
				prepend-avatar="https://randomuser.me/api/portraits/women/85.jpg"
				:title="
					this.$store.state.user.firstname +
					' ' +
					this.$store.state.user.lastname
				"
				:subtitle="this.$store.state.user.email"
				@click="$router.push('/profile')"
			></v-list-item>
		</v-list>

		<v-divider></v-divider>

		<v-list density="compact" nav>
			<v-list-item
				prepend-icon="mdi-home"
				title="Home"
				value="home"
				@click="$router.push('/')"
			></v-list-item>
			<v-list-item
				prepend-icon="mdi-account"
				title="User List"
				value="userlist"
				@click="$router.push('/user')"
			></v-list-item>
			<v-list-item
				prepend-icon="mdi-airport"
				title="Airport Browser"
				value="airportbrowser"
				@click="$router.push('/airports')"
			></v-list-item>
			<v-list-item
				prepend-icon="mdi-airplane-takeoff"
				title="Flights"
				value="flights"
				@click="$router.push('/flights')"
			></v-list-item>
			<v-list-item
				prepend-icon="mdi-airplane"
				title="Airplanes"
				value="airplanes"
				@click="$router.push('/planes')"
			></v-list-item>
		</v-list>
	</v-navigation-drawer>
</template>

<script>
export default {};
</script>

<style></style>
